import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { Card } from './ui/card';

export function SEOContent() {
  return (
    <section className="py-24 bg-zinc-950 relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-lime-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-lime-600/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section header */}
        <div className="text-center mb-16">
          <Badge 
            variant="secondary"
            className="mb-6 px-6 py-2 bg-zinc-900/50 border-lime-500/20"
          >
            <span className="text-sm font-medium text-lime-400">O nás</span>
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Autoservis s najmodernejšou
            <span className="block mt-3 bg-gradient-to-r from-lime-400 to-lime-300 bg-clip-text text-transparent">
              Technológiou
            </span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Teaser content */}
          <Card className="bg-zinc-900/50 backdrop-blur-sm border-zinc-800 p-8 md:p-12">
            <div className="space-y-6">
              <p className="text-xl text-zinc-300 leading-relaxed">
                <strong>BlackRent Servis</strong> je váš spoľahlivý partner pre starostlivosť o vozidlo. 
                Špecializujeme sa na komplexný servis všetkých značiek s dôrazom na prémiové automobily. 
              </p>

              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <span className="text-3xl">⚙️</span>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Najmodernejšie technológie</h3>
                    <p className="text-zinc-400">
                      Disponujeme <strong>Hunter HawkEye Elite 3D geometriou</strong>, <strong>TOPDON diagnostikou</strong> 
                      a <strong>ADAS kalibráciou</strong> pre komplexný servis vášho vozidla.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <span className="text-3xl">👨‍🔧</span>
                <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Certifikovaní mechanici</h3>
                    <p className="text-zinc-400">
                      Náš tím má dlhoročné skúsenosti so servisom BMW, Porsche, Mercedes-Benz, Audi a ďalších prémiových značiek.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <span className="text-3xl">🚗</span>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Náhradné vozidlá ZDARMA</h3>
                    <p className="text-zinc-400">
                      Ako jediní v regióne poskytujeme <strong>náhradné vozidlá 100% ZDARMA</strong> pri poistnej udalosti.
                    </p>
                  </div>
                </div>
              </div>

              <div className="pt-6 border-t border-zinc-700">
                <Button 
                  asChild
                  size="lg"
                  className="px-8 py-6 bg-lime-400 hover:bg-lime-300 text-black font-semibold rounded-xl transition-all hover:scale-105 shadow-lg shadow-lime-500/20 flex items-center gap-2"
                >
                  <Link to="/o-nas">
                    Zistiť viac o nás
                    <ArrowRight className="w-5 h-5" />
                  </Link>
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
}
